module.exports = __webpack_public_path__ + "static/assets/28bbfba41ada06bf49fc750088a8103a.svg";